import { buildClosedConfig, buildClosedOptions } from '../shared/closedConfig'

const FSMConfigVehicleNO = buildClosedConfig('QBFlowMachineVehicle')
const FSMOptionsVehicleNO = buildClosedOptions()

export { FSMConfigVehicleNO, FSMOptionsVehicleNO }
